import InquiryASFilter from './InquiryASFilter';
import InquiryPSRFilter from './InquiryPSRFilter';

const InquiryFilter = ({
  viewCode,
  ...filterProps
}: InquiryFilterViewsProps) => {
  const FilterComponent = {
    as: InquiryASFilter,
    psr: InquiryPSRFilter,
  }[viewCode];

  return FilterComponent ? <FilterComponent {...filterProps} /> : null;
};

export default InquiryFilter;
